export const FORM_INJECT_ANCHOR_CLASSNAME = 'pc-lead-form-anchor'

export const FORM_MAX_WIDTH_PX = 600
